import { dcpcApi } from './dcpcApi';

const TAG = 'NotificationSendingLogs';

dcpcApi.enhanceEndpoints({ addTagTypes: [TAG] });
const api = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getNotificationSendingLogs: builder.query({
      query: (urlParams) => ({
        url: 'notification-sending-logs',
        method: 'GET',
        params: urlParams,
      }),
      providesTags: [TAG],
    }),

    deleteNotificationsSendingLogs: builder.mutation({
      query: ({ userName, body }) => ({
        url: `notification-app-logs?userName=${userName}`,
        method: 'DELETE',
        body,
      }),
      invalidatesTags: [TAG],
    }),
  }),
});

export const {
  useLazyGetNotificationSendingLogsQuery,
  useDeleteNotificationsSendingLogsMutation,
} = api;

// Archive Notification
